module.exports = __webpack_public_path__ + "media/images/recruitment/landing/gigbase_logo-15032747b0fa8f3209b87bd509140c14.svg";